import { MembershipType } from "@prisma/client";
import parsePhoneNumber from "libphonenumber-js";
import { parseFullName } from "parse-full-name";
import { z } from "zod";

export const MembershipTypes = Object.values(MembershipType);
export type MembershipTypes = typeof MembershipTypes;

export const InvitationSchema = z.strictObject({
	companyName: z.string().trim().optional(),
	email: z.string().trim().email({ message: "Please add your email" }),
	membership: z.enum(MembershipTypes as [string, ...string[]]),
	name: z.preprocess(
		(val) => {
			const { error, first, last } = parseFullName(val as string);
			if (error && error.length > 0) return undefined;
			if (!first || !last) return undefined;
			return `${first} ${last}`;
		},
		z
			.string({
				message: "Please add your first and last name",
			})
			.trim(),
	),
	password: z
		.string({ message: "Please add your password" })
		.trim()
		.min(8, "Please add a longer password (over 8 characters)"),
	phoneNumber: z.preprocess(
		(val) => {
			if (!val || (typeof val === "string" && val.trim() === "")) return null;
			const phone = parsePhoneNumber(val as string);
			if (!phone?.isValid()) return undefined;
			return phone.formatInternational().replaceAll(" ", "");
		},
		z
			.string({
				message: "Please add your phone number (with country code)",
			})
			.trim(),
	),
	referrer: z.string().trim().optional(),
	signUpToMailingList: z.boolean().default(true),
});

export type InvitationSchemaType = z.infer<typeof InvitationSchema>;
